exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.card-header[data-v-a816bc90] {\n    cursor: pointer;\n}\n", ""]);

